module.exports = __webpack_public_path__ + "static/media/close_icon.15b0ee40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/playground/components/toggle/img/close_icon.svg
// module id = 406
// module chunks = 0